<template>
    <slot/>
</template>

<script setup lang="ts">
import { watch, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useWebInquiryActions } from '@/project/app/blocks/webinquiries/useWebInquiryActions';
import webInquirySubscribeOverlayService from '@/project/modals/overlays/WebInquirySubscribeOverlay.service';
import { UrlQueryKey } from '@/core/urlQueryKey';
import authService from '@/core/auth/auth.service';
import { router } from '@/router';
import loginFormOverlayService from '@/project/modals/overlays/LoginFormOverlay.service';

const route = useRoute();
let pendingTimer: ReturnType<typeof setTimeout> | undefined;

function resolveLoadTimeDelay(loadTime?: string): number {
    switch (loadTime?.split(' ').shift()) {
        case 'Medium': return 2000;
        case 'Slow': return 4000;
        default: return 0;
    }
}

async function checkForWebInquiryForm() {
    const id = route.query[UrlQueryKey.WebInquiry];
    if (!id || typeof id !== 'string') {
        return;
    }

    if (authService.isLoggedIn()) {
        try {
            const { loadWebInquiryActions } = useWebInquiryActions();
            const block = await loadWebInquiryActions(id);
            const delay = resolveLoadTimeDelay(block.loadTime ?? undefined);

            pendingTimer = setTimeout(() => {
                webInquirySubscribeOverlayService.show(block);
            }, delay);
        } catch {
        }
    } else {
        const path = router.currentRoute.value.path;
        const query = router.currentRoute.value.query
            ? Object.entries(router.currentRoute.value.query)
                .map(([key, value]) => `${key}=${value}`)
                .join('&')
            : '';

        await loginFormOverlayService.show('login', `${path}?${query}`);
        if (authService.isLoggedIn()) {
            checkForWebInquiryForm();
        }
    }
}

watch(
    () => route.query,
    () => {
        clearTimeout(pendingTimer);
        checkForWebInquiryForm();
    },
    { immediate: true },
);

onUnmounted(() => {
    clearTimeout(pendingTimer);
});
</script>
